import { createBrowserRouter, redirect } from 'react-router-dom';
import { App, loader as appLoader } from '../App';
import { Login, loader as loginLoader } from '../pages/Login';
import { ForgotPassword, ResetPassword } from '@enrich/shared-lib';
import BannerLogo from '../enrichLogo.png';
import MarketingImage from '../photo_marketing_presentation.jpg';
import { Dashboard } from '../pages/Dashboard';
import { Students } from '../pages/Students';
import { NonActiveStudents } from '../pages/NonActiveStudents';
import { NonActiveStudentsList } from '../pages/NonActiveStudentsList';
import { AllStudents } from '../pages/AllStudents';
import { Alumni } from '../pages/Alumni';
import { ActiveStudentsMenu } from '../pages/ActiveStudentsMenu';
import { MatchedCurrentStudents } from '../pages/MatchedCurrentStudents';
import { MatchedFutureStudents } from '../pages/MatchedFutureStudents';
import { NotMatchedStudents } from '../pages/NotMatchedStudents';
import {
    ContactProfile,
    contactLoader,
    ChangePassword,
    changePasswordLoader,
    CompaniesDashboard,
    CompanyProfile,
    companyProfileLoader,
} from '@enrich/shared-lib';
import { ErrorPage } from '../pages/ErrorPage';
import { ErrorMessages } from '../constants';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <ErrorPage message={ErrorMessages.noSchoolSlug} />,
    },
    {
        path: '/:schoolSlug/login',
        element: <Login />,
        loader: loginLoader,
    },
    {
        path: '/:schoolSlug/forgot-password',
        element: (
            <ForgotPassword
                slugParam="schoolSlug"
                loginPathTemplate="/:slug/login"
                resetPathTemplate="/:slug/reset-password"
                marketingImage={MarketingImage}
                bannerLogo={BannerLogo}
            />
        ),
    },
    {
        path: '/:schoolSlug/reset-password',
        element: (
            <ResetPassword
                slugParam="schoolSlug"
                dashboardPathTemplate="/:slug/dashboard"
                marketingImage={MarketingImage}
                bannerLogo={BannerLogo}
            />
        ),
    },
    {
        path: '/:schoolSlug/change-password',
        element: (
            <ChangePassword
                slugParam="schoolSlug"
                portalLabel="School Portal"
            />
        ),
        loader: (routeParams) =>
            changePasswordLoader({
                ...routeParams,
                slugParam: 'schoolSlug',
                entityKey: 'school',
            }),
    },
    {
        path: '/:schoolSlug',
        element: <App />,
        loader: appLoader,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                loader: ({ params }) =>
                    redirect(`/${params.schoolSlug}/dashboard`),
            },
            {
                path: 'dashboard',
                element: <Dashboard />,
            },
            {
                path: 'students',
                element: <Students />,
            },
            {
                path: 'students/:contactId',
                element: <ContactProfile showAdminActions={false} />,
                loader: contactLoader,
            },
            {
                path: 'non-active',
                element: <NonActiveStudents />,
            },
            {
                path: 'active-students',
                element: <ActiveStudentsMenu />,
            },
            {
                path: 'active-students/matched-current',
                element: <MatchedCurrentStudents />,
            },
            {
                path: 'active-students/matched-future',
                element: <MatchedFutureStudents />,
            },
            {
                path: 'active-students/not-matched',
                element: <NotMatchedStudents />,
            },
            {
                path: 'non-active/incomplete-resume',
                element: <NonActiveStudentsList filter="incomplete-resume" />,
            },
            {
                path: 'non-active/incomplete-coach-meeting',
                element: (
                    <NonActiveStudentsList filter="incomplete-coach-meeting" />
                ),
            },
            {
                path: 'non-active/unresponsive',
                element: <NonActiveStudentsList filter="unresponsive" />,
            },
            {
                path: 'alumni',
                element: <Alumni />,
            },
            {
                path: 'all-students',
                element: <AllStudents />,
            },
            {
                path: 'companies',
                element: <CompaniesDashboard showAdminActions={false} />,
            },
            {
                path: 'companies/:companyId',
                element: <CompanyProfile showAdminActions={false} />,
                loader: companyProfileLoader,
            },
        ],
    },
]);
